const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export class NotesService {

    /**
     * Get notes by status: 'active' (default), 'completed', 'deleted'
     */
    static async getAllNotes(authorizedFetch, status = 'active') {
        const res = await authorizedFetch(`${API_URL}/api/notes?status=${status}`);
        if (!res.ok) {
            throw new Error('Failed to fetch notes');
        }
        return res.json();
    }

    /**
     * Toggle note completed status
     */
    static async toggleComplete(authorizedFetch, noteId) {
        const res = await authorizedFetch(`${API_URL}/api/notes/${noteId}/toggle-complete`, {
            method: 'PATCH'
        });
        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || 'Failed to toggle note');
        }
        return res.json();
    }

    /**
     * Restore a completed/deleted note back to active
     */
    static async restoreNote(authorizedFetch, noteId) {
        const res = await authorizedFetch(`${API_URL}/api/notes/${noteId}/restore`, {
            method: 'PATCH'
        });
        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || 'Failed to restore note');
        }
        return res.json();
    }

    /**
     * Create a new note
     */
    static async createNote(authorizedFetch, noteData) {
        const res = await authorizedFetch(`${API_URL}/api/notes`, {
            method: 'POST',
            body: JSON.stringify(noteData)
        });
        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || 'Failed to create note');
        }
        return res.json();
    }

    /**
     * Update a note
     */
    static async updateNote(authorizedFetch, noteId, noteData) {
        const res = await authorizedFetch(`${API_URL}/api/notes/${noteId}`, {
            method: 'PUT',
            body: JSON.stringify(noteData)
        });
        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || 'Failed to update note');
        }
        return res.json();
    }

    /**
     * Delete a note
     */
    static async deleteNote(authorizedFetch, noteId) {
        const res = await authorizedFetch(`${API_URL}/api/notes/${noteId}`, {
            method: 'DELETE'
        });
        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || 'Failed to delete note');
        }
        return res.json();
    }
}
